<template>
  <div id="mProjectDetail" :class="pageClass" v-if="item.thumb">
    <Nav type="transparent" />
    <span class="pageTitle" v-html="pageTitle"></span>
    <div style="height: 1px;"></div>
    <div class="blockTit" v-html="item.name"></div>
    <img
      :src="require(`@/assets/${item.thumb}`)"
      class="pd-img"
      style="margin: 0 auto 64px;"
      alt
    />
    <p class="blockText" style="letter-spacing: -0.6px;">
      {{ item.intro }}
      <mu-icon
        class="mIcon"
        v-if="item.priceInfo"
        size="26"
        value="info_outline"
        @click="table = true"
      ></mu-icon>
    </p>

    <ul class="pdInfo">
      <li>
        <div>项目时间</div>
        <div class="con" v-html="item.time"></div>
      </li>
      <li>
        <div>项目价格</div>
        <div class="con" :class="{ link: item.priceBtn }" @click="item.priceBtn && (table = true)">
          <span v-html="item.priceM || item.price"></span>
          <div
            class="showListBtn"
            @click="toggleShowList"
            v-if="item.priceList || item.multyPriceList"
          >
            <span>会员价格</span>
            <span class="icon" :class="{ active: showList }">&or;</span>
          </div>
        </div>
      </li>
      <template v-if="item.multyPriceList">
        <li v-for="(n, i) in item.multyPriceList" :key="i" v-show="showList">
          <div></div>
          <div class="con">
            <span v-if="n.type != 'tag'" :class="`priceIcon ${n.type}`"></span>
            <span class="priceName" v-if="n.type == 'level1'">VIP卡</span>
            <span class="priceName" v-if="n.type == 'level2'"
              >明星卡</span
            >
            <span class="priceName" v-if="n.type == 'level3'"
              >钻石卡</span
            >
            <span class="tag" v-for="(v, ni) in n.value" :key="i+'-'+ni" v-html="(n.type == 'tag' ? '' : '¥') + `${v}`"></span>
          </div>
        </li>
      </template>
      <template v-if="item.priceList">
        <li v-for="(n, i) in item.priceList" :key="i" v-show="showList">
          <div></div>
          <div class="con">
            <span :class="`priceIcon ${n.type}`"></span>
            <span class="priceName" v-if="n.type == 'level1'">VIP卡</span>
            <span class="priceName" v-if="n.type == 'level2'">明星卡</span>
            <span class="priceName" v-if="n.type == 'level3'">钻石卡</span>
            <span v-html="`¥${n.value}`"></span>
          </div>
        </li>
      </template>
      <li>
        <div>项目部位</div>
        <div class="con" v-html="item.position"></div>
      </li>
      <li>
        <div>项目亮点</div>
        <div class="con" v-html="item.title"></div>
      </li>
    </ul>
    <div class="about-banner" style="margin-top: 80px;" v-if="item.sliderM">
      <div class="mid-container" style="padding-bottom: 10px;">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(n, i) in item.sliderM" :key="'sliderM'+i">
            <img :src="require(`@/assets/${n}`)" alt />
            <div v-if="item.sliderInnerTextM" class="textbox" v-html="item.sliderInnerTextM[i]"></div>
          </div>
        </div>
        <div class="mid-pagination"></div>
      </div>
    </div>
    <template v-for="(n, i) in item.sliderText">
      <div
        class="sliderText"
        v-if="i == realIndex"
        :key="'sliderText'+i"
        v-html="n"
      ></div>
    </template>
    <p class="blockText" style="margin: 80px auto 56px;">
      <strong>项目步骤</strong>
    </p>
    <template v-for="(n, i) in item.points">
      <div :key="i">
        <p class="blockText point" v-html="n.name"></p>
        <p class="blockText" v-html="n.text"></p>
        <img :src="require(`@/assets/${n.thumb}`)" class="pd-img" style="width: 330px;" alt />
      </div>
    </template>

    <!-- <div class="blockTit" style="margin-top: 150px;">面部护理其他项目</div>
    <div class="pd-banner" style="margin-top: 80px;">
        <div class="bottom-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in list" v-if="item.id != $route.params.id">
                    <router-link :to="`/ProjectDetail/${$route.params.type}/${item.id}`">
                        <img :src="`img/${item.thumb}`" alt="">
                        <p v-html="item.name"></p>
                    </router-link>
                </div>
            </div>
            <div class="bottom-pagination"></div>
        </div>
    </div>-->
    <mu-dialog title class="mTable" width="750" :open.sync="table">
      <i class="close" @click="table = false"></i>
      <div class="imgBox" v-if="item.priceInfo">
        <img :src="item.priceInfo.m" alt />
      </div>
    </mu-dialog>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
import data from '@/utils/projectData.js';
require('@/utils/swiper.min.js');
import('@/utils/swiper.min.css');
export default {
  name: 'mProjectDetail',
  data() {
    return {
      item: {},
      list: [],
      pageClass: '',
      pageTitle: '',
      realIndex: 0,
      showList: false,
      table: false,
    };
  },
  components: {
    Nav,
  },
  computed: {},
  watch: {
    '$route.params.id'(t) {
      this.getData();
    },
  },
  methods: {
    initBswiper() {
      new Swiper('.bottom-container', {
        // loop: true,
        pagination: {
          el: '.bottom-pagination',
        },
      });
    },
    getData() {
      let type,
        that = this;
      switch (this.$route.params.type) {
        case '1':
          type = 'skin';
          break;
        case '2':
          type = 'head';
          break;
        case '3':
          type = 'body';
          break;
        case '4':
          type = 'face';
          break;
        default:
          type = 'skin';
      }
      this.pageClass = data[type].pageClass;
      this.pageTitle = data[type].pageTitle;
      this.list = data[type].data;
      this.list.forEach((n) => {
        if (n.id == that.$route.params.id) {
          that.item = n;
        }
      });

      // document.querySelector('#app').scrollTop = 0;
    },
    initMswiper() {
      let slider = new Swiper('.mid-container', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: '.mid-pagination',
          // dynamicBullets: true,
        },
      });
      slider.on('slideChange', () => {
        this.realIndex = slider.realIndex;
      });
    },
    toggleShowList() {
      this.showList = !this.showList;
    },
  },
  mounted() {
    this.getData();
    // setTimeout(()=>{
    //     this.initBswiper();
    // }, 200);
    this.$nextTick(() => {
      this.initMswiper();
    });
  },
};
</script>

<style lang="scss" scoped>
#mProjectDetail {
  padding: 350px 32px 60px;
  background: url(../assets/project-banner.jpg) top/100% no-repeat;

  &.project1 {
    background-image: url(../assets/project-banner.jpg);
  }
  &.project2 {
    background-image: url(../assets/project-banner2.jpg);
  }
  &.project3 {
    background-image: url(../assets/project-banner3.jpg);
  }
  &.project4 {
    background-image: url(../assets/project-banner4.jpg);
  }
}
.blockTit {
  margin: 80px 0 80px;
  line-height: 56px;
}
.blockText {
  // line-height: 24px;
  font-size: 28px;
  line-height: 48px;
  text-align: left;
}
.project-banner {
  position: relative;
  overflow: hidden;
}
.pd-img {
  display: block;
  margin: 48px auto 80px;
}

.point {
  margin-bottom: 24px;
  line-height: 1;
  font-weight: 400;
}

.pdInfo {
  margin-top: 48px;
  border-bottom: 1px solid #e6e6e6;
  > li {
    display: flex;
    justify-content: space-between;
    min-height: 114px;
    border-top: 1px solid #e6e6e6;
    > div {
      display: flex;
      align-items: center;
      padding: 32px 0;
      font-size: 28px;
      line-height: 44px;
      color: #313131;
      &:first-child {
        flex-shrink: 0;
        margin-right: 48px;
      }
      &.con {
        display: flex;
        // flex-direction: column;
        // justify-content: center;
        align-items: center;
        font-weight: 400;

        span {
          font-weight: 400;
        }
        &.link {
          span {
            border-bottom: 1px solid #313131;
          }
        }
        .priceIcon {
          display: inline-block;
          width: 80px;
          height: 44px;
          background: left/46px 28px no-repeat;
          &.level1 {
            background-image: url(../assets/priceIcon1.png);
          }
          &.level2 {
            background-image: url(../assets/priceIcon2.png);
          }
          &.level3 {
            background-image: url(../assets/priceIcon3.png);
          }
        }
        .priceName {
          display: inline-block;
          padding-right: 15px;
          width: 100px;
          text-align: right;
          & + span {
            width: 90px;
            text-align: right;
          }
        }

        .tag {
          width: 180px!important;
          text-align: center!important;
        }
      }
    }
  }
}
.showListBtn {
  display: inline-flex;
  justify-content: center;
  margin-left: 15px;
  width: 168px;
  height: 52px;
  line-height: 52px;
  background: #d7caaa;

  .icon {
    margin-left: 8px;
    transform: rotate(180deg) scale(1, 0.45);
    transition: all 0.3s;
    &.active {
      transform: rotate(360deg) scale(1, 0.45);
    }
  }
}

.bottom-container {
  padding-bottom: 0;
  .swiper-slide {
    width: 540px;
    p {
      margin-top: 32px;
      font-size: 28px;
      line-height: 44px;
      color: #555;
      text-align: center;
    }
  }
}
.bottom-pagination {
  margin-top: 32px;
  text-align: center;
  span {
    margin: 0 15px !important;
    width: 14px !important;
    height: 14px !important;
    background: #acacac;
    border-radius: 0 !important;
    transform: rotate(45deg);
    &.swiper-pagination-bullet-active {
      background: #818181;
    }
  }
}

.mid-container {
  padding-bottom: 70px;
  overflow: hidden;
  .swiper-slide {
    width: 540px;
    p {
      margin-top: 40px;
      font-size: 28px;
      line-height: 43px;
      color: #555;
      text-align: center;
    }
  }
}
.mIcon {
  position: relative;
  top: 6px;
  color: #d1d1d1;
}
</style>
<style lang="scss">
#mProjectDetail .visiable-detail {
  display: block !important;
}
#mProjectDetail {
  .mBlock {
    display: block;
  }
  .sliderText {
    margin-top: 10px;
    font-size: 24px;
    font-weight: 400;
    color: rgba(85, 85, 85, 1);
    line-height: 43px;
    > p {
      display: flex;
      > span:last-child {
        flex: 1;
      }
    }
  }

  .textbox {
    position: absolute;
    left: 0;
    top: 400px;
    padding: 0 20px;
    width: 540px;
    height: 240px;

    p {
      margin: 0;

      &.st1 {
        font-weight: 500;
        font-size: 40px;
        line-height: 56px;
        color: #333;
      }
      &.st2 {
        font-weight: 500;
        font-size: 30px;
        line-height: 42px;
      }
      &.st3 {
        font-weight: 400;
        font-size: 32px;
        line-height: 45px;
      }
    }
  }
}
</style>
